import { Alert } from '@mui/material';
import { AlertProps } from '@mui/material';

interface BaseAlertProps extends AlertProps {
    message: string | null;
    severity?: 'error' | 'warning' | 'info' | 'success';
}

const BaseAlert = ({ message, severity = 'info', ...props }: BaseAlertProps) => {
    return (
        <Alert severity={severity} {...props}>
            {message}
        </Alert>
    );
};

export default BaseAlert;
